export const SALES_LIKE_ROLES = ['sales', 'support'] as const
export const ASSIGNABLE_REVIEW_ROLES = ['admin', 'dev'] as const

export const isSalesLikeRole = (role: string | null | undefined) =>
  SALES_LIKE_ROLES.includes((role || '') as (typeof SALES_LIKE_ROLES)[number])

export const isAssignableReviewRole = (role: string | null | undefined) =>
  ASSIGNABLE_REVIEW_ROLES.includes((role || '') as (typeof ASSIGNABLE_REVIEW_ROLES)[number])

export const isAssignableTaskCapabilityProfile = (
  profile:
    | {
        is_coder?: boolean | null
        is_tester?: boolean | null
        is_2nd_tester?: boolean | null
      }
    | null
    | undefined
) => Boolean(profile?.is_coder || profile?.is_tester || profile?.is_2nd_tester)
